import React from 'react';
import IncomeErrorMessage from './IncomeErrorMessage';
import {DATA_FIELDS_ID} from '../constants';
import GrossYearlyIncome from './GrossYearlyIncome';
import {ToolTip} from '../../../components/ToolTip/ToolTip';
import FOMOInfoIcon from '../../../assets/icons/info-circle-filled-white.svg';

function GrossYearlyIncomeWrapper({dispatch, customerData}) {
  return (
    <div className='prequal--web--input-container prequal--web--bootstrap-styles prequal--wc--input-container'>
      <div className='prequal--wc--input-tooltip-container'>
        <div className='form-floating'>
          <GrossYearlyIncome type='text' id={DATA_FIELDS_ID.INCOME} income={customerData.income} dispatch={dispatch} />

          <label
            className='prequal--wc--prequal-form-label postal-code-label prequal--web--prequal-form-label-dark'
            htmlFor={DATA_FIELDS_ID.INCOME}
          >
            Gross Yearly Income
          </label>
        </div>
        {!customerData.isDealerHostApplication.value && (
          <div className='prequal--wc--input-tooltip-section'>
            <ToolTip
              content={
                <p>
                  Your gross yearly income should account for any recent changes to your job status. It may include part-time work and
                  alternative sources of income.
                  <br />
                  <br />
                  You don&apos;t have to include alimony, child support, or separate maintenance payments if you don&apos;t want us to
                  consider it.
                </p>
              }
              position='left-start'
              tooltipIcon={FOMOInfoIcon}
              header='Gross Yearly Income'
            />
          </div>
        )}
      </div>
      {customerData.income.errorMessage && (
        <IncomeErrorMessage
          id='income-error-message'
          className='prequal--web--fomo-error-message'
          errorMessage={customerData.income.errorMessage}
        />
      )}
    </div>
  );
}

export default GrossYearlyIncomeWrapper;
